/* eslint-disable indent */
import DateFnsUtils from '@date-io/date-fns';
import { makeStyles, Tooltip, Typography, useTheme } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { orange } from '@material-ui/core/colors';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import TextField from '@material-ui/core/TextField';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import { Autocomplete } from '@material-ui/lab';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { enUS, id } from 'date-fns/locale';
import React, { useEffect, useRef, useState } from 'react';
import { Controller } from 'react-hook-form';
import { browseFileMessage } from '../../utils/constant';
import { rulesToInfoStr } from '../../utils/transformer';
import { fileValidationFitter } from '../../utils/validator';

export const InputField = ({
  attr,
  defaultValue = '',
  register,
  req = false,
  rules = {},
  addInfo = '',
  isTask = false,
  error = null,
  fullWidth = true,
  type = 'text',
  shrink = null,
  ...props
}) => {
  const [infoText, setInfoText] = useState(null);

  const theme = useTheme();

  useEffect(() => {
    const comInfoText = rulesToInfoStr(rules);
    setInfoText(isTask ? comInfoText : comInfoText);
  }, []);

  if (rules && rules.required && rules.required.value === true) {
    req = true;
  }

  return (
    <div
      style={
        addInfo === ''
          ? {
              width: '100%',
            }
          : {
              width: '100%',
              marginBottom: theme.spacing(2),
            }
      }
    >
      <TextField
        type={type}
        name={attr}
        defaultValue={defaultValue}
        inputRef={register(rules ? { ...rules } : {})}
        label={attr + (req ? ' *' : '')}
        variant="outlined"
        fullWidth={fullWidth}
        error={error !== null}
        InputLabelProps={shrink !== null ? { shrink: shrink } : {}}
        helperText={error ? error.message : infoText}
        data-testid={'InputField' + attr}
        style={
          addInfo !== ''
            ? {
                marginBottom: 0,
              }
            : {}
        }
        {...props}
      />
      {addInfo !== '' ? (
        <Typography
          color="textSecondary"
          variant="caption"
          style={{
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
          }}
        >
          Informasi Tambahan : {addInfo}
        </Typography>
      ) : (
        <></>
      )}
    </div>
  );
};

export const ReactHookFormComboBox = ({
  attr,
  control,
  defaultValue = '',
  options,
  req = false,
  error = null,
  rules = null,
  addInfo = '',
  isTask = false,
  disabled = false,
  ...props
}) => {
  const [infoText, setInfoText] = useState(null);
  const result = options?.filter((option) => option?.value === defaultValue);
  const [value, setValue] = useState(
    result ? (result[0] ? result[0] : null) : null
  );

  const theme = useTheme();

  if (rules && rules.required && rules.required.value === true) {
    req = true;
  }

  useEffect(() => {
    const comInfoText = rulesToInfoStr(rules);
    setInfoText(isTask ? comInfoText : comInfoText);
  }, []);
  return (
    <div
      style={
        addInfo === ''
          ? {
              width: '100%',
            }
          : {
              width: '100%',
              marginBottom: theme.spacing(2),
            }
      }
    >
      <Controller
        render={({ onChange, onBlur }) => (
          <Autocomplete
            options={options}
            data-testid={'ComboBox' + attr}
            disabled={disabled}
            onChange={(_, data) => {
              if (data !== null && data !== undefined) {
                error = null;
                onChange(data.value);
                const valresult = options.filter(
                  (option) => option.value === data.value
                );
                setValue(valresult[0] ? valresult[0] : null);
              } else {
                onChange(null);
              }
            }}
            onBlur={() => {
              onBlur();
            }}
            getOptionLabel={(option) => option.label}
            value={value}
            renderInput={(params) => (
              <TextField
                {...params}
                name={attr + '-textfield'}
                label={attr + (req ? ' *' : '')}
                variant="outlined"
                error={error !== null}
                helperText={error ? error.message : infoText}
                disabled={disabled}
                style={
                  addInfo !== ''
                    ? {
                        marginBottom: 0,
                      }
                    : {}
                }
                {...props}
              />
            )}
          />
        )}
        name={attr}
        control={control}
        defaultValue={value ? value.value : defaultValue}
        rules={{ ...rules }}
      />
      {addInfo !== '' ? (
        <Typography
          color="textSecondary"
          variant="caption"
          style={{
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
          }}
        >
          Informasi Tambahan : {addInfo}
        </Typography>
      ) : (
        <></>
      )}
    </div>
  );
};

export const ReactHookFormDatePicker = ({
  attr,
  control,
  dateFormat = 'dd/MM/yyyy', // If you want to be able to let the user write the date inside the textfield as well as using the calendar picker, make sure to only use formats that will only show up as numbers
  // dateInputMask = 'dd MM yyyy',
  defaultValue = '',
  req = false,
  error = null,
  rules = null,
  isTask = false,
  addInfo = '',
  shrink = null,
  ...props
}) => {
  const localeMap = {
    en: enUS,
    id: id,
  };
  const [locale] = useState('id');

  const [infoText, setInfoText] = useState(null);
  const [value, setValue] = useState(
    defaultValue ? new Date(defaultValue) : null
  );

  const theme = useTheme();

  if (rules && rules.required && rules.required.value === true) {
    req = true;
  }

  const formatHelperText = (infoTextStr) => {
    let str = '';
    if (infoTextStr !== '') {
      str += ', ';
    }
    str += 'Format : ' + dateFormat;
    return str;
  };

  // const inputEl = useRef(null);
  // const KDP = useRef(null);

  useEffect(() => {
    const comInfoText = rulesToInfoStr(rules);
    setInfoText(isTask ? comInfoText : comInfoText);
  }, []);

  return (
    <MuiPickersUtilsProvider
      utils={DateFnsUtils}
      locale={localeMap[locale]}
      style={
        addInfo === ''
          ? {}
          : {
              marginBottom: theme.spacing(2),
            }
      }
    >
      <Controller
        render={({ onChange, onBlur }) => (
          <KeyboardDatePicker
            // ref={KDP}
            name={attr}
            data-testid={'DatePick' + attr}
            label={attr + (req ? ' *' : '')}
            onChange={(date) => {
              setValue(date);
              onChange(date);
            }}
            onBlur={() => {
              onBlur();
            }}
            value={value}
            inputVariant="outlined"
            InputLabelProps={shrink !== null ? { shrink: shrink } : {}}
            helperText={
              error ? error.message : infoText + formatHelperText(infoText)
            }
            format={dateFormat}
            error={error !== null}
            clearable
            cancelLabel="BATAL"
            clearLabel="HAPUS"
            okLabel="OKE"
            style={
              addInfo !== ''
                ? {
                    marginBottom: 0,
                  }
                : {}
            }
            {...props}
          />
        )}
        name={attr}
        control={control}
        defaultValue={defaultValue}
        rules={{ ...rules }}
      />
      {addInfo !== '' ? (
        <Typography
          color="textSecondary"
          variant="caption"
          style={{
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
          }}
        >
          Informasi Tambahan : {addInfo}
        </Typography>
      ) : (
        <></>
      )}
    </MuiPickersUtilsProvider>
  );
};

const RHFUploadStyle = makeStyles((theme) => ({
  multilineColor: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.warning.light
        : theme.palette.warning.dark,
  },
  multilineSelected: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.success.light
        : theme.palette.success.dark,
  },
  multilineSelectedHoverLink: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.primary.light
        : theme.palette.primary.dark,
    cursor: 'pointer',
  },
  multilineInvalid: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.error.light
        : theme.palette.error.dark,
  },
  browseButton: {
    background:
      'linear-gradient(25deg, ' +
      String(theme.palette.steicolors.darkside) +
      '30' +
      ' 0%, ' +
      String(theme.palette.steicolors.lightside) +
      '30' +
      ' 100%)',

    color: theme.palette.type === 'dark' ? '#e0e0e0' : '#4e4e4e',
    '&:hover': {
      color: orange[300],
    },
  },
}));

export const ReactHookFormUpload = ({
  attr,
  register,
  triggerValidation = null,
  defaultValue = null,
  req = false,
  error = null,
  type = 'file',
  rules = {},
  label = null,
  acceptedType = null,
  placeholder = 'Unggah file Anda',
  addInfo = '',
  ...props
}) => {
  const theme = useTheme();

  const labelId = `${attr}-label`;

  const classes = RHFUploadStyle();

  const [placeholderText, setPlaceHolderText] = useState(placeholder);

  const [infoText, setInfoText] = useState(null);
  const [filenamesClickHelper, setFilenamesClickHelper] = useState(0);
  const [eventHelper, setEventHelper] = useState(false);
  const [renderCount, setRenderCount] = useState(0);
  const [valRules, setValRules] = useState({});

  if (rules && rules.required && rules.required.value === true) {
    req = true;
  }

  useEffect(() => {
    const comInfoText = rulesToInfoStr(valRules);
    setInfoText(comInfoText);
  }, []);

  if (renderCount === 0) {
    let newRules = fileValidationFitter(rules, acceptedType);
    setValRules(newRules);

    setRenderCount(1);
  }

  useEffect(() => {
    // setInfoText(comInfoText);
    if (defaultValue) {
      if (inputEl.current) {
        inputEl.current.childNodes[0].files = defaultValue;
        filesSelected(defaultValue);
      }
    }
  }, []);

  const filesSelected = (fileObjList) => {
    let fileNames = '';
    for (let index = 0; index < fileObjList.length; index++) {
      const element = fileObjList[index];
      fileNames += element.name;

      if (index !== fileObjList.length - 1) {
        fileNames += ', ';
      }
    }
    if (fileNames === '') {
      fileNames = placeholder;
    }
    setPlaceHolderText(fileNames);

    if (triggerValidation) {
      triggerValidation(attr);
    }
  };

  // They're to let the users open the selected file(s) (in a new tab)
  const inputEl = useRef(null);
  const openSelFilesInNewTab = (files) => {
    for (let file of files) {
      window.open((window.URL || window.webkitURL).createObjectURL(file));
    }
  };

  const InputButton = () => (
    <label id={labelId} htmlFor={'input-button-' + attr}>
      <Button
        id={labelId}
        variant="outlined"
        color="primary"
        component="span"
        startIcon={<InsertDriveFileIcon />}
        style={{ marginTop: 0, marginBottom: 0, marginRight: 12 }}
        className={classes.browseButton}
      >
        {browseFileMessage}
      </Button>
    </label>
  );

  const textFieldInput = useRef(null);
  let helpa = 0;
  useEffect(() => {
    if (!eventHelper) {
      window.requestAnimationFrame(() => {
        if (
          textFieldInput !== null &&
          textFieldInput !== undefined &&
          textFieldInput.current !== null
        ) {
          const textFieldInputInput = textFieldInput.current?.childNodes[1];

          textFieldInputInput.addEventListener('mouseenter', () => {
            if (helpa < 1) {
              helpa = 1;
              setFilenamesClickHelper(1);
            }
          });
          textFieldInputInput.addEventListener('mouseleave', () => {
            helpa = 0;
            setFilenamesClickHelper(0);
          });
          textFieldInputInput.addEventListener('mousedown', () => {
            helpa = 2;
          });
          textFieldInputInput.addEventListener('mousemove', () => {
            if (helpa === 2) {
              helpa = 3;
            }
          });

          textFieldInputInput.addEventListener('mouseup', () => {
            if (helpa === 2) {
              openSelFilesInNewTab(inputEl.current.childNodes[0].files);
            }
            helpa = 0;
            setFilenamesClickHelper(0);
          });
        }
      });

      setEventHelper(true);
    }
  });

  return (
    <FormControl
      name={attr}
      variant="outlined"
      style={
        addInfo === ''
          ? {
              width: '100%',
            }
          : {
              width: '100%',
              marginBottom: theme.spacing(2),
            }
      }
    >
      <Input
        inputRef={register(valRules ? { ...valRules } : {})}
        data-testid={'FileUploadInput' + attr}
        hidden
        type={type}
        name={attr}
        inputProps={acceptedType ? { accept: acceptedType } : {}}
        style={{ display: 'none' }}
        id={'input-button-' + attr}
        onChange={(e) => {
          filesSelected(e.target.files);
        }}
        error={error !== null}
        ref={inputEl}
      />
      <TextField
        label={(label ? label : attr) + (req ? ' *' : '')}
        data-testid={'FileUploadTextField' + attr}
        variant="outlined"
        fullWidth
        value={placeholderText}
        // required={req}
        style={
          addInfo !== ''
            ? {
                marginBottom: 0,
              }
            : {}
        }
        error={error !== null}
        helperText={error ? error.message : infoText}
        InputProps={{
          startAdornment: <InputButton />,
          readOnly: true,
          className: error
            ? classes.multilineInvalid
            : placeholderText === placeholder
            ? classes.multilineColor
            : filenamesClickHelper === 1
            ? classes.multilineSelectedHoverLink
            : classes.multilineSelected,
          ref: textFieldInput,
        }}
        {...props}
      />
      <Tooltip
        arrow
        open={
          placeholderText !== placeholder &&
          (filenamesClickHelper === 1 || filenamesClickHelper === 2)
        }
        title="Klik untuk membuka file yang sudah dipilih di tab baru"
      >
        <div
          style={{
            width: '10%',
            height: '24%',
            position: 'absolute',
            top: 30,
            bottom: 'auto',
            left: '50%',
            cursor: 'pointer',
            pointerEvents: 'none',
          }}
        />
      </Tooltip>
      {addInfo !== '' ? (
        <Typography
          color="textSecondary"
          variant="caption"
          style={{
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
          }}
        >
          Informasi Tambahan : {addInfo}
        </Typography>
      ) : (
        <></>
      )}
    </FormControl>
  );
};
